(function () {
  "use strict";

angular
  .module('trainerWebApp.directives')
  .directive('mfHome', mfHome);

  function mfHome() {
    return {
      restrict: 'A',
      link: function (scope, iElement, iAttrs) {
        scope.$watch('homeState.sidebarContentSrc', function () {
          $(window).trigger('resize');
        });
      }
    }
  }

})();
